module.exports = __webpack_public_path__ + "img/ymi.54b56c1f.png";